export const ISSUES_LIMIT = { limit: 3 }

export const DATA_OPENED_IN_DRAWER = "data-opened-in-drawer"

export const CHECKBOX_ISSUE_DATA_ID =
  "data-id-checkbox-issue-expanded-row-triage"
